import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../envs/environment';
import { Auth } from '../services/auth';

export const authGuard: CanActivateFn = async (route, state) => {
  if (environment.skipAuth) return true;

  const auth = inject(Auth);
  const router = inject(Router);
  const redirectState = await auth.waitForInit();

  if (redirectState) {
    return router.parseUrl(redirectState);
  }

  if (!auth.isAuthenticated()) {
    await auth.login(state.url);
    return false;
  }

  return true;
};
